import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const swapVerticalIcon: SvgIconData = {
  viewBox: '1.51 2.29 11.97 10.07',
  element: (
    <g>
      <path d="M4.91 2.526a.9.9 0 0 0-1.213.002L1.74 4.323a.7.7 0 0 0 .946 1.032l1.62-1.486 1.637 1.488a.7.7 0 1 0 .942-1.036z" />
      <path d="M4.314 2.32a.7.7 0 0 1 .7.7v8.646a.7.7 0 1 1-1.4 0V3.02a.7.7 0 0 1 .7-.7m6.97 9.812a.9.9 0 0 1-1.214-.002l-1.957-1.795a.7.7 0 1 1 .946-1.032l1.62 1.486 1.637-1.488a.7.7 0 1 1 .942 1.036z" />
      <path d="M10.687 12.339a.7.7 0 0 0 .7-.7V2.992a.7.7 0 1 0-1.4 0v8.647a.7.7 0 0 0 .7.7" />
    </g>
  ),
};
